function addFacetAriaLabels(root = document) {
  root.querySelectorAll('.wizzy-facet-list-item-label').forEach(function (label) {
    var input = label.querySelector('.wizzy-facet-list-item-checkbox-input');
    var valueEl = label.querySelector('.facet-item-label-value');

    if (!input || !valueEl) return;

    var text = valueEl.textContent.trim();
    if (text && input.getAttribute('aria-label') !== text) {
      input.setAttribute('aria-label', text);
    }
  });
}

// Page load par chalao
document.addEventListener('DOMContentLoaded', function () {
  addFacetAriaLabels();
});

// Wizzy filters/facets dynamically reload hote hain, isliye naye elements ke liye bhi chalao
var facetObserver = new MutationObserver(function () {
  addFacetAriaLabels();
});
facetObserver.observe(document.body, { childList: true, subtree: true });


(function () {
  function init() {
    document.querySelectorAll('.collapsible').forEach(function (wrapper, i) {
      var heading = wrapper.querySelector('.collapsible-heading');
      var content = wrapper.querySelector('.content');
      if (!heading || !content || heading.dataset.a11yV2) return;

      // Heading clone: iss par lage purane listeners khatam
      var h = heading.cloneNode(true);
      h.dataset.a11yV2 = '1';
      h.removeAttribute('data-a11y-bound');
      heading.parentNode.replaceChild(h, heading);
      heading = h;

      // Icon button: purane attributes hatao, sirf decoration
      var btn = heading.querySelector('.collapsible-btn');
      if (btn) {
        ['role', 'tabindex', 'aria-label', 'aria-expanded', 'aria-controls', 'data-a11y-bound']
          .forEach(function (a) { btn.removeAttribute(a); });
        btn.setAttribute('aria-hidden', 'true');
      }

      if (!heading.id) heading.id = 'collapsible-heading-' + i;
      if (!content.id) content.id = 'collapsible-content-' + i;

      var isOpen = wrapper.classList.contains('collapsible-is-open') ||
                   content.classList.contains('active');

      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-controls', content.id);
      content.setAttribute('role', 'region');
      content.setAttribute('aria-labelledby', heading.id);

      function setState(open) {
        heading.setAttribute('aria-expanded', String(open));
        wrapper.classList.toggle('collapsible-is-open', open);
        content.classList.toggle('active', open);
        if (btn) btn.classList.toggle('active', open);
      }
      setState(isOpen);

      var last = 0;
      // Capture phase + stopImmediatePropagation: purani script ke handlers nahi chalenge
      heading.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        var now = Date.now();
        if (now - last < 300) return; // double event ka safety guard
        last = now;
        setState(heading.getAttribute('aria-expanded') !== 'true');
      }, true);

      // Keyboard sirf click trigger karta hai, khud toggle nahi karta
      heading.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          e.stopPropagation();
          heading.click();
        }
      }, true);
    });
  }

  if (!document.getElementById('a11y-collapsible-style')) {
    var s = document.createElement('style');
    s.id = 'a11y-collapsible-style';
    s.textContent =
      '.collapsible-heading{cursor:pointer}' +
      '.collapsible-heading:focus-visible{outline:2px solid #005fcc;outline-offset:2px}';
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


document.querySelectorAll('.product-badges__badge').forEach((btn) => {
  btn.removeAttribute('aria-expanded');
  btn.setAttribute('aria-haspopup', 'true');
});